<template>

     <el-card>
      <div class="card-header">
        <h4 class="title">Customer Enrollments</h4>
       
 
      </div>
      <div class="card-content">
      
            <div class="col-xs-12">
           
              <order-list v-if="customer.enrollments" :orders="customer.enrollments"></order-list>
              <div v-else>No Current Enerollments</div>
            </div>
    

      </div>
  
    </el-card>

</template>

<script>
//import api from "../api";
//import complexapi from '../../../api/complexApi'
import gql from "graphql-tag";
import OrderList from "./OrderList";
import { mapGetters } from "vuex";
import { VueTabs } from "vue-nav-tabs";


import moment from 'moment'

export default {
  components: {
    OrderList,
    VueTabs
  },
  props: ["id", "customer"],
  data() {
    return {
      customToolbar: [
        [{ 'size': ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{'align': ''}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
        ['link', 'image'],
        ['clean'],
      ],
      editorSettings: {
        bounds: '#quill-container'
      },
      notes: [],
      newNote: "",
      orders: [],
      customerID: ""
    };
  },
  computed: {
    ...mapGetters(["getCustomer"]),

     user(){
        const token = localStorage.getItem('vuex')
        const parsed = JSON.parse(token)
        return parsed['auth']
      }
  },

  methods: {
    handleTabChange(tab, event) {
      console.log('Getting '+tab.label);
      //console.log("getCustomer ", this.getCustomer);
      if (tab.label === "Bookings") {
      //  this.getCustomerOrders();
      }
      if (tab.label === "Notes") {
       // this.getCustomerNotes();
      }
    },
   
    saveNote() {
     this.newNote = this.stripHTML()
     let q=gql`
     mutation AddNote {
        insert_Note(objects: {customerId: ${this.customer.id}, detail: "${this.newNote}", createdBy: "${this.user.email}",dateCreated:"${moment().format('YYYY-MM-DDTHH:mm:ss')}"}) {
          returning {
            id
            detail,
            createdBy,
            dateCreated
          }
        }
      } `
     this.$apollo
     .mutate({
           mutation: q
        }).then(result => {
          console.log(result)
          this.customer.notes.unshift(result.data.insert_Note.returning[0])
          this.$notify({
            title: "Updated",
            message: "Note Saved",
            type: "success"
          });
    }) 
    },
    createOrder(){
      this.$router.push({ path: "/order/create/?customer_id=" + this.customer.id })
    },
    deleteNote(id) {
      let q=gql`
        mutation MyMutation {
          __typename
          delete_Note(where: {id: {_eq: ${id}}}) {
            affected_rows
          }
        }
      `
      this.$apollo
      .mutate({
        mutation: q
      }).then(result => {
        this.customer.notes = _.reject(this.customer.notes, (o) => {
          return o.id == id;
        });
        this.$notify({
          title: "Updated",
          message: "Note Deleted",
          type: "success"
        });
      }) 
   },
   stripHTML(){
      const text = this.newNote                                                                                                                                                                                                                                                                                                                                                                                                          
      var pastedData = text.replace(/(<([^>]+)>)/ig,""); // remove all html except the listed tags                                                                                                                                                
                                                                                                                                                                                                                                                
      let wrapper = document.createElement('div')                                                                                                                                                                                               
      wrapper.innerHTML = pastedData 
      
      var sanitised = wrapper.textContent || wrapper.innerText;                                                                                                                                                                                               
      this.newNote = sanitised;

      return this.newNote                                                                                                                                                                                        
    }
  },

  mounted() {
    
  },

  watch: {
    "$route.params.id": function(id) {
      this.customerID = id;
    }
  }
};
</script>
<style>
.vue-tabs .tab-content {
  text-align: left !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Customers/CustomerProfile/CustomerOrderInfo.vue